import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import { SAPstatus } from '../models/samcastatus.entity';
import { ApiService } from '../../../services/api.service';
import { AuthenticationService } from '../../../services/authentication.service';

/**
 * Base url for api
 */
const BASE_URL = 'samca-status';

@Injectable({
  providedIn: 'root'
})

/**
 * SAP status Service
 */
export class SAPstatusService {

  /**
   * Is loading
   */
  public loading$: Observable<boolean>;

  /**
   * Constructor
   *
   * @param apiService ApiService
   * @param httpClient HttpClient
   * @param authenticationService AuthenticationService
   */
  constructor(private apiService: ApiService, private  httpClient: HttpClient, private authenticationService: AuthenticationService) {
    this.loading$ = this.apiService.loading$;
  }



  /**
   * list
   *
   */
  list(): Observable<SAPstatus[]> {
    return this.apiService.post(`${BASE_URL}/list`).pipe(map(
      statuss => statuss.map(
        (status) => SAPstatus.createFromJson(status))
      )
    );
  }


}